import React, {useEffect, useMemo, useRef, useState} from "react";
import {NewUserWrap} from "components/atoms/Customers/ManageUser/AddNewUser/AddNewUser.styles";
import Form from "components/molecules/Form/Form";
import {useForm} from "components/molecules/Form";
import Button from "components/molecules/Button";
import Field from "components/molecules/Field";
import user_profile from "assets/Customerrs/userIcon.png";
import {MdCameraAlt} from "react-icons/md";
import adminService from "services/adminService";
import manageStores from "services/manageSores";
import {useSelector} from "react-redux";
import {convertToFormData} from "helpers/common";
import Toast from "components/molecules/Toast";
import {useAuthContext} from "Context/authContext";
import {useMediaPredicate} from "react-media-hook";
import Tooltip from "components/molecules/Tooltip";
import {MdInfoOutline} from "react-icons/md";
const AddNewUser = ({onClose, editUser, data}) => {
    const {business} = useSelector(state => state);
    const {refetch} = useAuthContext();

    const [form] = useForm();

    const {roles_data} = adminService.GetRoles({
        getAll: true,
        businessId: business?.businessId,
    });

    const {stores_data} = manageStores.GetAllStores({
        getAll: true,
        businessId: business?.businessId,
    });

    const [userProfile, setUserProfile] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleFileChange = event => {
        const file = event.target.files[0];
        if (file) {
            setUserProfile(file);
        }
    };
    const handleSubmit = async e => {
        const selectedRole = e.Role?.map(elem => elem.value);
        const selectedStores = e.Branches?.map(elem => elem.value);
        setLoading(true);
        if (!data) {
            const payload = {
                first_name: e?.first_name,
                email: e?.email,
                roles: selectedRole,
                storeIds: selectedStores,
                profilePicture: userProfile,
                businessId: Array.isArray(business?.businessId) ? business?.businessId[0] : business?.businessId,
                type: "restaurant_employee",
            };
            const data = convertToFormData(payload);
            try {
                const resp = await adminService.createEmployee(data);
                refetch();
                Toast({type: "success", message: resp?.message});
            } catch (error) {
                Toast({type: "error", message: error?.message});
            } finally {
                setLoading(false);
            }
        } else {
            const payload = {
                first_name: e?.first_name,
                email: e?.email,
                roles: selectedRole,
                storeIds: selectedStores,
            };
            // Only include profilePicture when a new file is selected (File object),
            // not when it's an existing S3 URL string — avoids bloating the multipart
            // request which triggers AWS WAF/ALB 403 blocks.
            if (userProfile && userProfile instanceof File) {
                payload.profilePicture = userProfile;
            }
            const formData = convertToFormData(payload);
            try {
                const resp = await adminService.updateEmployee(formData, data?._id);
                refetch();
                Toast({type: "success", message: resp?.message});
            } catch (error) {
                Toast({type: "error", message: error?.message});
            } finally {
                setLoading(false);
            }
        }
    };
    const role = useMemo(() => roles_data.roles.map(({_id, type}) => ({value: _id, label: type})), [roles_data]);

    const branches = useMemo(() => stores_data.stores.map(({_id, name}) => ({value: _id, label: name})), [stores_data]);

    useEffect(() => {
        if (data) {
            setUserProfile(data?.profilePicture);
            form.setFieldsValue({
                first_name: data?.profile?.first_name,
                email: data?.email,
                Role: role?.filter(elem => data?.roles.find(({_id}) => _id === elem?.value)),
                Branches: branches?.filter(elem => data?.storeIds?.find(id => id === elem?.value)),
            });
        }
    }, [data, roles_data]);
    return (
        <>
            <NewUserWrap>
                <Form form={form} onSubmit={handleSubmit}>
                    <div className="image-wrap">
                        <label htmlFor="image">
                            {userProfile && typeof userProfile === "string" ? (
                                <img src={userProfile} alt="user_profile" />
                            ) : (
                                <img
                                    src={userProfile ? URL.createObjectURL(userProfile) : user_profile}
                                    alt="user_profile"
                                />
                            )}

                            <MdCameraAlt className="edit-icon" />
                        </label>
                        <input
                            id="image"
                            type="file"
                            style={{display: "none"}}
                            accept="image/*"
                            onChange={handleFileChange}
                        />
                    </div>
                    <div className="user-fields">
                        <Form.Item
                            label="User Name"
                            type="name"
                            rounded
                            name="first_name"
                            lg
                            placeholder="Enter Text"
                            $bgWhite
                            rules={[
                                {
                                    required: true,
                                    message: "User Name is Required",
                                },
                            ]}>
                            <Field />
                        </Form.Item>
                        <Form.Item
                            label="Email Address"
                            type="email"
                            rounded
                            name="email"
                            lg
                            placeholder="Enter Text"
                            $bgWhite
                            disabled={data}
                            rules={[
                                {
                                    required: true,
                                    message: "User Email is Required",
                                },
                            ]}>
                            <Field />
                        </Form.Item>
                    </div>
                    <div className="user-fields">
                        <Form.Item
                            label="Manage Branches"
                            type="select"
                            rounded
                            name="Branches"
                            lg
                            placeholder="Select Branches"
                            $bgWhite
                            isMulti
                            menuPosition={"fixed"}
                            options={branches}
                            rules={[
                                {
                                    required: true,
                                    message: "At least one branch is Required",
                                },
                            ]}>
                            <Field />
                        </Form.Item>
                    </div>
                    <div className="user-fields">
                        <Form.Item
                            label="Role"
                            type="select"
                            rounded
                            name="Role"
                            lg
                            placeholder="General Manager"
                            $bgWhite
                            isMulti
                            menuPosition={"fixed"}
                            options={role}
                            rules={[
                                {
                                    required: true,
                                    message: "Role is Required",
                                },
                            ]}>
                            <Field />
                        </Form.Item>
                    </div>

                    <div className="btn-holder">
                        {editUser ? (
                            <Button lg type="submit" loader={loading}>
                                Save Changes
                            </Button>
                        ) : (
                            <Button lg type="submit" loader={loading}>
                                Add User
                            </Button>
                        )}
                    </div>
                </Form>
            </NewUserWrap>
        </>
    );
};

export default AddNewUser;
